
const Header = () => {
    const title = 'Choice Maker App';

    return ( 
        <div className="header">
            <h1>{title}</h1>
        </div>
    );
}
 
export default Header;